function onPageShow() {
    if (pageTransitionEnabled && pageTransition) {
        pageTransition.enter(function () {
            $(window).trigger('transitionDone');
        });
    } else {
        $(window).trigger('transitionDone');
    }
}
